/**
 * CalculateDetailContainer
 * --
 */
import React from 'react';
import CalculateDetailPresenter from './CalculateDetailPresenter';

const CalculateDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <CalculateDetailPresenter />
    </>
  );
};

export default CalculateDetailContainer;
